<template>
  <div class="inline-flex items-center gap-1 font-medium" :class="displayClasses">
    <font-awesome-icon :class="displayClasses" :icon="icon" />
    <span :class="displayClasses">{{ label }}</span>
  </div>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "OpenStatusValue",
  computed: {
    value() {
      return this.params.valueFormatted !== null && this.params.valueFormatted !== undefined
        ? this.params.valueFormatted
        : this.params.value;
    },
    displayClasses() {
      return !this.value ? "text-green" : "text-orange-500";
    },
    icon() {
      return !this.value ? "check-circle" : "exclamation-circle";
    },
    label() {
      return !this.value ? "Closed" : "Open";
    },
  },
});
</script>
